import { getWeightWarningTagColorName } from '../../../../utils/vehicleUtils'

export const summaryColumns = [
  {
    id: 'day',
    label: 'Day',
    labelAlign: 'left',
    align: 'left',
    hide: []
  },
  {
    id: 'count',
    label: 'Routes with overweight',
    labelAlign: 'left',
    align: 'left',
    hide: []
  }
]

export const log_columns = [
  {
    id: 'startEndTime',
    isSortable: false,
    minWidth: 75,
    labelAlign: 'left',
  },
  {
    id: 'startAddress',
    label: 'From',
    labelAlign: 'left',
    minWidth: 50,
    hide: ['mobile', 'tablet'],
    colSpan: 2,
    isSortable: true,
    isSmallColumn: true,
    splitOnComma: true
  },
  {
    id: 'endAddress',
    label: 'To',
    labelAlign: 'left',
    minWidth: 50,
    hide: ['mobile'],
    colSpan: 2,
    isSortable: true,
    isSmallColumn: true,
    splitOnComma: true
    
  },
  {
    id: 'distance',
    label: 'Distance',
    hide: [],
    align: 'left',
    minWidth: 150,
    isSortable: true,
    labelAlign: 'left',
  },
  {
    id: 'vehicle',
    label: 'Vehicle',
    hide: [],
    align: 'left',
    minWidth: 150,
    isSortable: true,
    labelAlign: 'left',
  },
  // {
  //   id: 'purpose',
  //   label: 'Purpose',
  //   // isTag: true,
  //   tagColor: (purpose) => {
  //     return purpose
  //   },
  //   hide: [],
  //   minWidth: 120,
  //   isSortable: true,
  // },
  {
    id: 'weight_gross',
    label: 'Gross Weight',
    // isTag: true,
    // tagColor: (weight_percent) => {
    //   if(typeof(weight_percent) === 'undefined') return false

    //   if(weightString.indexOf('%') !== -1) {
    //     try {
    //       let percent_overweight = parseInt(weightString.split(' ')[2].substring(1, bob.length - 1))
              
    //       if(percent_overweight >= 107) return 'issue'
    //       if(percent_overweight >= 10) return 'warning'
    //       if(percent_overweight >= 107) return 'primary'
    //     } catch {
    //       return false
    //     }
    //   }
    // },
    minWidth: 180,
    hide: [],
    isSortable: true,
  },
  {
    id: 'weight_front',
    label: 'Front',
    isTag: true,
    textColor: 'black',
    tagColor: (weight_percent) => {
      if(typeof(weight_percent) === 'undefined') return false

      if(weight_percent.indexOf('%') !== -1) {
        try {
          const percent_overweight = parseInt(weight_percent.split(' ')[0])

          return getWeightWarningTagColorName(percent_overweight)

        } catch {
          return false
        }
      }
    },
    minWidth: 180,
    hide: [],
    isSortable: true,
  },
  {
    id: 'weight_rear',
    label: 'Rear',
    isTag: true,
    textColor: 'black',
    tagColor: (weight_percent) => {
      if(typeof(weight_percent) === 'undefined') return false

      if(weight_percent.indexOf('%') !== -1) {
        try {
          const percent_overweight = parseInt(weight_percent.split(' ')[0])

          return getWeightWarningTagColorName(percent_overweight)

        } catch {
          return false
        }
      }
    },
    minWidth: 180,
    hide: [],
    isSortable: true,
  },
]